import { render, staticRenderFns } from "./corp-edit-modal.vue?vue&type=template&id=8d083606&"
import script from "./corp-edit-modal.vue?vue&type=script&lang=js&"
export * from "./corp-edit-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports